import add from "@/assets/add.svg";
import edit from "@/assets/edit.svg";
import trashSolid from "@/assets/trash-solid.svg";
import Button, { BUTTON_VARIANT } from "@/common/elements/Button";
import { INPUT_VARIANT } from "@/common/elements/InputElements/const";
import Table from "@/common/elements/Table";
import { Flex, IntakeSectionHeader } from "@/common/styles";
import { useEffect, useState } from "react";
import {
  FormContainer,
  InmateDetailsTableContainer,
  TableHeader,
} from "../InmateDetails/styles";
import ChargesInformationModal, { MODE } from "./ChargesInformationModal";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { setBookings } from "@/slices/bookingsSlice";
import { getRefListNameByID } from "@/util/common_function";

const headers = [
  { key: "sequence", text: "#" },
  { key: "offenseDate", text: "Offense Date" },
  { key: "ucrCode", text: "Code" },
  { key: "chargeLevel", text: "Level" },
  { key: "chargeDescription", text: "Charges" },
  { key: "actions", text: "Actions" },
];

const ChargesInformation = ({ formData, disabled, onChargesChange }) => {
  const dispatch = useDispatch();
  const bookings = useSelector((state) => state?.bookings?.bookings);
  const [modalShown, setModalShown] = useState(false);

  const [chargeInfoList, setChargeInfoList] = useState([]);
  const [selectChargeInfo, setSelectChargeInfo] = useState(null);

  useEffect(() => {
    setChargeInfoList(() => formData);
  }, [formData]);

  // useEffect(() => {
  //   dispatch(
  //     setBookings({
  //       detentions: [
  //         {
  //           ...bookings?.detentions?.[0],
  //           detentionsCharges: chargeInfoList,
  //         },
  //       ],
  //     })
  //   );
  // }, [chargeInfoList]);

  const onModalHide = () => {
    setModalShown(false);
  };
  const onAddClick = () => {
    if (!disabled) setModalShown(true);
  };
  const onEditClick = (value, index) => {
    if (!disabled) {
      setSelectChargeInfo(() => value);
      setModalShown(true);
    }
  };

  const closeModal = () => {
    setModalShown(() => false);
  };

  const saveChargeInfo = (values, id) => {
    const updatedList = chargeInfoList?.map((p) => {
      if (p?.id === id) {
        return {
          ...p,
          ...values,
          offenseDate: dayjs(values?.offenseDate)?.format("MM/DD/YYYY"),
        };
      }
      return p;
    });
    setChargeInfoList(updatedList);
    if (onChargesChange) {
      onChargesChange(updatedList);
    }
    closeModal();
  };

  const onDeleteClick = () => {
    window.confirm(
      "Are you sure you want to delete a court information from the inmate record"
    );
  };

  return (
    <>
      <section>
        <IntakeSectionHeader>
          <span>Charges</span>
        </IntakeSectionHeader>
        <FormContainer>
          <InmateDetailsTableContainer>
            <TableHeader>
              <h6>Detention Charges</h6>
              {/* <Button
                color="primary"
                type="primary"
                className="add-btn"
                onClick={onAddClick}
              >
                <img alt="Add Icon" src={add} /> &nbsp; Add
              </Button> */}
            </TableHeader>
            <Table
              headers={headers}
              data={
                chargeInfoList?.map((el, index) => ({
                  ...el,
                  sequence: index + 1,
                  chargeLevel: getRefListNameByID(
                    "Charge_Level",
                    el?.chargeLevelID
                  ),
                  chargeDescription: getRefListNameByID(
                    "Charges",
                    el?.chargeDescriptionID
                  ),
                  actions: disabled ? null : (
                    <Flex gap="10px">
                      <Button
                        variant={BUTTON_VARIANT.TEXT_DARK}
                        style={{ padding: "unset" }}
                        onClick={() => onEditClick(el, index)}
                      >
                        <img alt="Modify Icon" src={edit} />
                      </Button>
                      {/* <Button
                        variant={BUTTON_VARIANT.TEXT_DARK}
                        style={{ padding: "unset" }}
                        onClick={onDeleteClick}
                      >
                        <img alt="Modify Icon" src={trashSolid} />
                      </Button> */}
                    </Flex>
                  ),
                })) || []
              }
              variant={INPUT_VARIANT.INTAKE_FORM}
              style={{ padding: "unset" }}
            />
          </InmateDetailsTableContainer>
        </FormContainer>
      </section>
      {!disabled && (
        <ChargesInformationModal
          show={modalShown}
          onHide={onModalHide}
          mode={MODE.EDIT}
          selectChargeInfo={selectChargeInfo}
          forwardSave={saveChargeInfo}
        />
      )}
    </>
  );
};

export default ChargesInformation;
